import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";

import useGetCarAddOn from "../../../store/selectors/get-car-add-on";
import useStoreCarAddOn from "../../../store/actions/store-car-add-on";

import useGetCarAddOnSelection from "../../../store/selectors/get-car-add-on-selection";
import useStoreCarAddOnSelection from "../../../store/actions/store-car-add-on-selection";
import useGetCarPlan from "../../../store/selectors/get-car-plan-quote";

import BottomMessagePopUp from "../../../components/BottomMessagePopUp";
import useGetVehicleInfo from "../../../store/selectors/get-vehicle-info";
import FloatLabelInput from "../../../components/FloatingLabel";

import "../../../assets/styles/add-on-others.css";

const AddOnOthers = () => {
	const allAddOns = useGetCarAddOn();
	const storeAddOn = useStoreCarAddOn();
	const navigate = useNavigate();
	const selectedPlan = useGetCarPlan();

	const addOnSelection = useGetCarAddOnSelection();
	const setAddOnSelection = useStoreCarAddOnSelection();
	const getVehicleInfo = useGetVehicleInfo();

	const [selectedAddOns, setSelectedAddOns] = useState([]);

	const [no_of_driver, setNoOfDriver] = useState(2);

	const [selectedVariant, setSelectedVariant] = useState(() => {
		const cachedVariant = localStorage.getItem("selectedVariant");
		return cachedVariant ? JSON.parse(cachedVariant) : null;
	});

	const handleDriverChange = (value) => {
		setNoOfDriver(value);
		localStorage.setItem("no_of_driver", value);
	};

	const [errorMessage, setErrorMessage] = useState("");
	const [isErrorVisible, setIsErrorVisible] = useState(false);
	const showErrorMessage = (msg) => {
		setErrorMessage(msg);
		setIsErrorVisible(true);
	};

	const fallbackIconUrl = `${process.env.REACT_APP_API_URL}/assets/img/motor-add-ons/additional-icon.png`;

	const addOnsWithoutIcons = allAddOns.filter(
		(addOn) => !addOn.imgSrc || addOn.imgSrc === fallbackIconUrl
	);

	//onsole.log("THIS IS ADD ON WITHOUT ICONS: ", addOnsWithoutIcons);

	useEffect(() => {
		const persistedSelection = addOnSelection.map(
			(addOn) => `${addOn.insurerName}-${addOn.code}-${addOn.title}`
		);
		setSelectedAddOns(persistedSelection);
	}, [addOnSelection]);

	const getDOBFromId = (idNo) => {
		const regex = /^(\d{6})\d{2}\d{3}(\d{1})$/;
		const match = idNo.match(regex);
	
		if (!match) {
		  	throw new Error("Invalid ID number format");
		}
	
		const birthDate = match[1];
		const genderDigit = parseInt(match[2], 10);
	
		const yearPrefix = birthDate.substring(0, 2);
		const month = birthDate.substring(2, 4);
		const day = birthDate.substring(4, 6);
	
		const currentYear = new Date().getFullYear();
		const currentCentury = Math.floor(currentYear / 100) * 100;
	
		let fullYear;
	
		if (parseInt(yearPrefix, 10) <= currentYear % 100) {
		  	fullYear = `20${yearPrefix}`;
		} else {
		  	fullYear = `19${yearPrefix}`;
		}
	
		const dob = new Date(`${fullYear}-${month}-${day}`);
	
		const age = currentYear - dob.getFullYear();
	
		if (isNaN(dob) || age < 0 || age > 120) {
			throw new Error("Invalid birth year in ID number");
		}
	
		const gender = genderDigit % 2 === 0 ? "F" : "M";
	
		const formattedDob = dob.toISOString().split("T")[0];
	
		return {
			dob: formattedDob,
			gender: gender,
			age: age,
			};
	};

	const handleCheckboxChange = (e, addOn) => {
		const uniqueId = `${addOn.insurerName}-${addOn.code}-${addOn.title}`;

		// Get current selection
		let updatedSelection;

		const paPlans = ["PA1", "PA2", "PA3", "PA4"];
		const isPA = paPlans.includes(addOn.code);

		const sdpaPlans = ["R1", "R2"];
		const isSDPA = sdpaPlans.includes(addOn.code);

		const takafulIkhlasMotorcyclistPAPlans = ["MTD004C1", "MTD004C2", "MTD004C3", "MTD004C4"];
		const isTakafulIkhlasMotorcyclistPAPlans = takafulIkhlasMotorcyclistPAPlans.includes(addOn.code);
		
		const isALD = addOn.code === "ALD"; // 04
		const isAND = addOn.code === "AND"; // 01
		const isNamedDrivers = addOn.code === "E303"; // TMIM named drivers

		const isNAME = addOn.code === "NAME"; // Generali - Additional driver
		const isB205 = addOn.code === "B205"; // Generali - Additional driver

		if (e.checked) {
			if (isPA) {
				const isOtherPASelected = addOnSelection.some(
					(item) => paPlans.includes(item.code) && item.code !== addOn.code
				);
			
				if (isOtherPASelected) {
					showErrorMessage("Only one plan can be selected.");
					return;
				}
			}

			if (isSDPA) {
				const isOtherSDPASelected = addOnSelection.some(
					(item) => sdpaPlans.includes(item.code) && item.code !== addOn.code
				);
			
				if (isOtherSDPASelected) {
					showErrorMessage("Only one SDPA plan can be selected.");
					return;
				}
			}

			if (isTakafulIkhlasMotorcyclistPAPlans) {
				const isOtherPASelected = addOnSelection.some(
					(item) => takafulIkhlasMotorcyclistPAPlans.includes(item.code) && item.code !== addOn.code
				);
			
				if (isOtherPASelected) {
					showErrorMessage("Only one Motorcyclist PA plan can be selected.");
					return;
				}
			}

			// Prevent selection of AND if ALD is already checked
			if (isAND || isNamedDrivers) {
				if (addOnSelection.some((item) => item.code === "ALD")) {
					showErrorMessage(
						`Either ALL LICENSED DRIVERS OR ADDITIONAL NAMED DRIVER can be selected.`
					);
					return; // Do nothing if ALD is already checked
				}

				let drivers;
				if (isAND) {
					drivers = JSON.parse(localStorage.getItem("drivers")) || [];
					if (drivers.length > 0) {
						drivers[0].name =
							getVehicleInfo?.owner_name || drivers[0].name;
						localStorage.setItem(
							"drivers",
							JSON.stringify(drivers)
						);
					}
				}

				if (isNamedDrivers) {
					drivers = JSON.parse(localStorage.getItem("drivers")) || [];
					if (drivers.length > 0) {
						localStorage.setItem(
							"drivers",
							JSON.stringify(drivers)
						);
					}
				}

				const queryParameters = new URLSearchParams(
					window.location.search
				);
				const policyId = queryParameters.get("policy_id");

				navigate(
					policyId
						? `/get-quote/add-on-drivers?policy_id=${policyId}`
						: `/get-quote/add-on-drivers`,
					{ state: { addOn } } // Pass the selected add-on to the new page
				);
			}

			// Prevent selection of ALD if AND is already checked
			if (isALD) {
				// const queryParameters = new URLSearchParams(window.location.search);
				// const policyId = queryParameters.get("policy_id");

				// navigate(
				//     policyId
				//         ? `/get-quote/add-on-drivers?policy_id=${policyId}`
				//         : `/get-quote/add-on-drivers`,
				//     { state: { addOn } } // Pass the selected add-on to the new page
				// );

				const drivers = [
					{
						code: "04",
						name: "ALL DRIVERS",
					},
				];

				localStorage.setItem("drivers", JSON.stringify(drivers));

				if (addOnSelection.some((item) => item.code === "AND")) {
					showErrorMessage(
						`Either ALL LICENSED DRIVERS OR ADDITIONAL NAMED DRIVER can be selected.`
					);
					return; // Do nothing if ALD is already checked
				}
			}

			if (addOn.code === "A-AD") {
				if (addOnSelection.some((item) => item.code === "A-UD")) {
					showErrorMessage(
						`Either UNLIMITED DRIVERS OR ADDITIONAL NAMED DRIVER can be selected.`
					);
					return;
				}

				const adddriver =
					JSON.parse(localStorage.getItem("allianz_adddriver")) || [];
				if (adddriver.length >= 0) {
					const driver = {
						name: getVehicleInfo?.owner_name || adddriver[0].name,
						icnumber: getVehicleInfo?.id_no || adddriver[0].icnumber,
					}
					adddriver[0] = driver;
					
					localStorage.setItem("allianz_adddriver", JSON.stringify(adddriver));
				}

				const queryParameters = new URLSearchParams(
					window.location.search
				);
				const policyId = queryParameters.get("policy_id");

				navigate(
					policyId
						? `/get-quote/allianz-add-driver?policy_id=${policyId}`
						: `/get-quote/allianz-add-driver`,
					{ state: { addOn } } // Pass the selected add-on to the new page
				);
			}

			if (addOn.code === "A-UD") {
				if (addOnSelection.some((item) => item.code === "A-AD")) {
					showErrorMessage(
						`Either UNLIMITED DRIVERS OR ADDITIONAL NAMED DRIVER can be selected.`
					);
					return;
				}
			}

			if (isNAME || isB205) {
				let id_data;
				if (
					(
						getVehicleInfo.id_type === "nric" || getVehicleInfo.id_type === "NRIC"
					) 
					&& getVehicleInfo.id_no
				) {
					id_data = getDOBFromId(getVehicleInfo.id_no);
				}
	
				const adddriver =
					JSON.parse(localStorage.getItem("adddriver")) || [];
				if (adddriver.length >= 0) {
					const driver = {
						name: getVehicleInfo?.owner_name || adddriver[0].name,
						icnumber: getVehicleInfo?.id_no || adddriver[0].icnumber,
						drvdob: id_data?.dob || adddriver[0].drvdob,
						drvgender: id_data?.gender || adddriver[0].drvgender,
						drvrel: "INSD" || adddriver[0].drvrel,
					}
					adddriver[0] = driver;
					
						localStorage.setItem("adddriver", JSON.stringify(adddriver));
				}

				const queryParameters = new URLSearchParams(
					window.location.search
				);
				const policyId = queryParameters.get("policy_id");

				navigate(
					policyId
						? `/get-quote/add-driver?policy_id=${policyId}`
						: `/get-quote/add-driver`,
					{ state: { addOn } } // Pass the selected add-on to the new page
				);
			}

			if (addOn.code === "MPA") {
				const queryParameters = new URLSearchParams(
					window.location.search
				);
				const policyId = queryParameters.get("policy_id");
				navigate(
					policyId
						? `/get-quote/add-on-mpa?policy_id=${policyId}`
						: `/get-quote/add-on-mpa`,
					{ state: { addOn } } // Pass the selected add-on to the new page
				);
			}

			if (addOn.code === "M51" || addOn.code === "E112") {
				const queryParameters = new URLSearchParams(
					window.location.search
				);
				const policyId = queryParameters.get("policy_id");

				navigate(
					policyId
						? `/get-quote/add-on-lonpac-cart?policy_id=${policyId}`
						: `/get-quote/add-on-lonpac-cart`,
					{ state: { addOn } } // Pass the selected add-on to the new page
				);
			}

			if (addOn.code === "P07A") {
				if (addOnSelection.some((item) => item.code === "P10A")) {
					showErrorMessage(
						"Either Loss of Use (LOU) or Compensation when your vehicle is under repair (CART) can be selected."
					);
					return; // Do nothing if P10A is already checked
				}

				const queryParameters = new URLSearchParams(
					window.location.search
				);
				const policyId = queryParameters.get("policy_id");

				navigate(
					policyId
						? `/get-quote/add-on-etiqa-cart?policy_id=${policyId}`
						: `/get-quote/add-on-etiqa-cart`,
					{ state: { addOn } } // Pass the selected add-on to the new page
				);
			}

			if (addOn.code === "P10A") {
				if (addOnSelection.some((item) => item.code === "P07A")) {
					showErrorMessage(
						"Either Loss of Use (LOU) or Compensation when your vehicle is under repair (CART) can be selected."
					);
					return; // Do nothing if P10A is already checked
				}

				const queryParameters = new URLSearchParams(
					window.location.search
				);
				const policyId = queryParameters.get("policy_id");

				navigate(
					policyId
						? `/get-quote/add-on-etiqa-lou?policy_id=${policyId}`
						: `/get-quote/add-on-etiqa-lou`,
					{ state: { addOn } } // Pass the selected add-on to the new page
				);
			}

			if (addOn.code === "PA*P") {
				const queryParameters = new URLSearchParams(
					window.location.search
				);
				const policyId = queryParameters.get("policy_id");
				navigate(
					policyId
						? `/get-quote/add-on-pa?policy_id=${policyId}`
						: `/get-quote/add-on-pa`,
					{ state: { addOn } } // Pass the selected add-on to the new page
				);
			}

			if (addOn.code === "A001") {
				const queryParameters = new URLSearchParams(
					window.location.search
				);
				const policyId = queryParameters.get("policy_id");
				navigate(
					policyId
						? `/get-quote/add-on-a001?policy_id=${policyId}`
						: `/get-quote/add-on-a001`,
					{ state: { addOn } } // Pass the selected add-on to the new page
				);
			}

			if (addOn.code === "112") {
				const queryParameters = new URLSearchParams(
					window.location.search
				);
				const policyId = queryParameters.get("policy_id");

				navigate(
					policyId
						? `/get-quote/add-on-sompo-cart?policy_id=${policyId}`
						: `/get-quote/add-on-sompo-cart`,
					{ state: { addOn } } // Pass the selected add-on to the new page
				);
			}

			if (addOn.code === "D027") {
				const queryParameters = new URLSearchParams(
					window.location.search
				);
				const policyId = queryParameters.get("policy_id");

				navigate(
					policyId
						? `/get-quote/add-on-d027?policy_id=${policyId}`
						: `/get-quote/add-on-d027`,
					{ state: { addOn } } // Pass the selected add-on to the new page
				)
			}

			if (addOn.code === "D01A") {
				const queryParameters = new URLSearchParams(
					window.location.search
				);
				const policyId = queryParameters.get("policy_id");

				navigate(
					policyId
						? `/get-quote/add-on-d01a?policy_id=${policyId}`
						: `/get-quote/add-on-d01a`,
					{ state: { addOn } } // Pass the selected add-on to the new page
				)
			}

			if (addOn.code === "PAB-ERW") {
				const queryParameters = new URLSearchParams(window.location.search);
				const policyId = queryParameters.get("policy_id");

				navigate(
					policyId
						? `/get-quote/add-on-paberw?policy_id=${policyId}`
						: `/get-quote/add-on-paberw`,
					{ state: { addOn } } // Pass the selected add-on to the new page
				)
			}

			if (addOn.code === "PAB3") {
				const queryParameters = new URLSearchParams(window.location.search);
				const policyId = queryParameters.get("policy_id");

				navigate(
					policyId
						? `/get-quote/add-on-pab3?policy_id=${policyId}`
						: `/get-quote/add-on-pab3`,
					{ state: { addOn } } // Pass the selected add-on to the new page
				)
			}

			// Add the new selection
			updatedSelection = [...addOnSelection, { ...addOn, id: uniqueId }];

			// if 53C1 or 53C2 is selected, deselect the other one
			if (addOn.code === "53C1") {
				updatedSelection = updatedSelection.filter(
					(item) => item.code !== "53C2"
				);
			}
			if (addOn.code === "53C2") {
				updatedSelection = updatedSelection.filter(
					(item) => item.code !== "53C1"
				);
			}

			// if 54C1 or 54C2 is selected, deselect the other one
			if (addOn.code === "54C1") {
				updatedSelection = updatedSelection.filter(
					(item) => item.code !== "54C2"
				);
			}
			if (addOn.code === "54C2") {
				updatedSelection = updatedSelection.filter(
					(item) => item.code !== "54C1"
				);
			}
		} else {
			if (addOn.code === "E112" || addOn.code === "M51") {
				updatedSelection = addOnSelection.filter(item => item.code !== addOn.code);
				setAddOnSelection(updatedSelection);
				setSelectedAddOns(selectedAddOns.filter(id => !id.includes(addOn.code)));
				return;
			}

			// Remove the add-on if unchecked
			updatedSelection = addOnSelection.filter(
				(item) => item.id !== uniqueId && item.id !== addOn.id
			);
		}

		setAddOnSelection(updatedSelection); // Update Redux state

		// Update local state
		const newSelectedAddOns = updatedSelection
			.filter((item) =>
				addOnsWithoutIcons.some(
					(addOnsWithoutIcons) =>
						`${addOnsWithoutIcons.insurerName}-${addOnsWithoutIcons.code}-${addOnsWithoutIcons.title}` ===
						item.id
				)
			)
			.map((item) => item.id);

		setSelectedAddOns(newSelectedAddOns);

		const sumInsuredCodes = ["E89", "WSCR", "89", "101", "102", "97A", "89A", "E97", "W/S", "windScreen", "rideEasy", "motorCyclePA"];
		// Check if the selected add-on requires navigation
		if (e.checked && sumInsuredCodes.includes(addOn.code)) {
			const queryParameters = new URLSearchParams(window.location.search);
			const policyId = queryParameters.get("policy_id");

			navigate(
				policyId
					? `/get-quote/add-on-sum-insured?policy_id=${policyId}`
					: `/get-quote/add-on-sum-insured`,
				{ state: { addOn } } // Pass the selected add-on to the new page
			);
		}
	};

	const handleButtonClick = () => {
		const queryParameters = new URLSearchParams(window.location.search);
		const policyId = queryParameters.get("policy_id");

		console.log("addOnSelection", addOnSelection);
		navigate(
			policyId
				? `/get-quote/add-ons?policy_id=${policyId}`
				: `/get-quote/add-ons`,
			{
				replace: true,
				state: { addOnSelection },
			}
		);
	};

	const removeEndorsementHeading = (text) => {
		if (!text) return "";

		// Regex to remove "ENDORSEMENT <code> - " at the beginning of the string
		const cleanedText = text.replace(
			/^ENDORSEMENT\s?[A-Za-z0-9]*\s?-\s?/i,
			""
		);

		return cleanedText.trim(); // Remove any extra spaces at the start or end
	};

	return (
		<div className="addon-others-wrapper">
			<h3 className="addon-title">
				Other{" "}
				{selectedAddOns.filter((id) =>
					addOnsWithoutIcons.some(
						(addOn) =>
							id ===
							`${addOn.insurerName}-${addOn.code}-${addOn.title}`
					)
				).length > 0 && (
					<span className="selected-count">
						{
							selectedAddOns.filter((id) =>
								addOnsWithoutIcons.some(
									(addOn) =>
										id ===
										`${addOn.insurerName}-${addOn.code}-${addOn.title}`
								)
							).length
						}
					</span>
				)}
			</h3>
			<div className="addon-grid">
				{addOnsWithoutIcons
					.filter((addOn) => {
						if (addOn.code === "BCW" || addOn.code === "NH02" || addOn.code === "BTWP") {
							const vehicleMakeYear = getVehicleInfo?.vehicle_details?.make_year;

							// only 5-12 years old
							const thisYear = new Date().getFullYear();
							if (vehicleMakeYear && (thisYear - vehicleMakeYear >= 5) && (thisYear - vehicleMakeYear <= 12)) {
								return true;
							} else {
								return false;
							}
						}
						if (addOn.code === "M68") {
							const vehicleMakeYear = getVehicleInfo?.vehicle_details?.make_year;

							// only 5-15 years old
							const thisYear = new Date().getFullYear();
							if (vehicleMakeYear && (thisYear - vehicleMakeYear >= 5) && (thisYear - vehicleMakeYear <= 15)) {
								return true;
							} else {
								return false;
							}
						}
						if (addOn.code === "MPA") {
							if (
								selectedVariant?.variant_seat &&
								!isNaN(parseInt(selectedVariant?.variant_seat))
							) {
								return true;
							} else {
								return false;
							}
						}
						if (addOn.code === "M63") {
							return false
						}
						return true;
					})
					.map((addOn) => (
						<>
							<div
								key={`${addOn.insurerName}-${addOn.code}-${addOn.title}`}
								className="addon-item"
							>
								<label
									htmlFor={`addOn-${addOn.insurerName}-${addOn.code}-${addOn.title}`}
									className="addon-details"
								>
									{removeEndorsementHeading(addOn.title)}
								</label>
								<Checkbox
									inputId={`addOn-${addOn.insurerName}-${addOn.code}-${addOn.title}`}
									value={`${addOn.insurerName}-${addOn.code}-${addOn.title}`} // Use the combined key as the value
									checked={selectedAddOns.includes(
										`${addOn.insurerName}-${addOn.code}-${addOn.title}`
									)}
									onChange={(e) =>
										handleCheckboxChange(e, addOn)
									}
									disabled={
										addOn.code === "E303" &&
										Number(no_of_driver) < 3
									}
								/>
							</div>
							{addOn.code === "E303" && (
								<div className="driver-input-wrapper">
									<FloatLabelInput
										label="No. of Drivers"
										value={no_of_driver}
										onChange={(e) =>
											handleDriverChange(e.target.value)
										}
										placeholder=""
									/>
								</div>
							)}
						</>
					))}
				<BottomMessagePopUp
					style={{ marginBottom: "65px" }}
					message={errorMessage}
					type="error"
					isVisible={isErrorVisible}
					onClose={() => setIsErrorVisible(false)}
				/>
			</div>
			<div className="sticky-bottom">
				<Button
					label={
						selectedAddOns.filter((id) =>
							addOnsWithoutIcons.some(
								(addOn) =>
									id ===
									`${addOn.insurerName}-${addOn.code}-${addOn.title}`
							)
						).length > 0
							? "Return add-ons"
							: "Skip for Now"
					}
					className="proceed-button"
					onClick={handleButtonClick}
				/>
			</div>
		</div>
	);
};

export default AddOnOthers;
